import objectValues from 'lodash/values'
import classNames from 'classnames'

/**
 * Classnames will be created for each entry in the style prop.
 * Defaults to defaultProps.style
 * @param {object} styles
 * @param {string} styleProp
 */
export default function mapStyleToClassName (styles, styleProp) {
  const mappedStyles = objectValues(styleProp).map((className) => styles[className])
  return classNames(...mappedStyles)
}
